export default {
    SET_ITEM: "SET_ITEM",
    SET_FORM_ITEM: "SET_FORM_ITEM",
    SET_PROCESSING: "SET_PROCESSING",
    SET_INITIALIZE_ONBOARDING_DETAILS: "SET_INITIALIZE_ONBOARDING_DETAILS",
    SET_ERROR: "SET_ERROR",
    SET_WARNING: "SET_WARNING"
};
